import React from 'react'

// Hooks
import { useState } from 'react';

// React Router
import { useNavigate } from 'react-router-dom';

// MUI
import { Box, TextField, InputAdornment, Button } from '@mui/material';
import { Add } from '@mui/icons-material';

// Context
import { useContext } from 'react';
import { DataContext } from "../../contexts/CartProvider";

// UUID
import { v4 as uuidv4 } from "uuid";

export default function Create() {
    const context = useContext(DataContext);
    const { items, setItems } = context;

    const [item, setItem] = useState("");
    const [price, setPrice] = useState("");

    const addItem = () => {
        const newItem = { item, price, id: uuidv4() };
        const newItems = [...items, newItem];
        setItems(newItems);
        localStorage.setItem("cart", JSON.stringify(newItems));
    };

    const navigate = useNavigate();
    const [loading, setLoading] = React.useState(false);

    async function handleClick() {
        setLoading(true);
        await new Promise((res) => setTimeout(res, 500));
        setLoading(false);

        if(item!==""){
            addItem();
            navigate("../home");
        } else {
            alert("Enter An Item In 'Transaction' Input");
        }
    }

    const handleEdit = () => {
        let realPrice = parseInt(price);
        setPrice(`${realPrice}`);
        const priceNumber = parseInt(price, 10);
        if (isNaN(priceNumber)) {
            alert("Enter A Valid Number In 'Amount' Input");
            return;
        }

        handleClick();
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "30px" }}>
            <TextField
                label="Transaction Title"
                sx={{ width: { xs: "100%", sm: "300px" } }}
                variant="filled"
                autoComplete="off"
                value={item}
                onChange={(e) => {
                    setItem(e.target.value);
                }}
            />
            <TextField
                label="Amount"
                sx={{ width: { xs: "100%", sm: "300px" } }}
                slotProps={{
                    input: {
                        startAdornment: <InputAdornment position="start">$</InputAdornment>,
                    },
                }}
                variant="filled"
                autoComplete="off"
                value={price}
                onChange={(e) => {
                    setPrice(e.target.value);
                }}
            />
            <Button
                size="small"
                onClick={handleEdit}
                endIcon={<Add />}
                loading={loading}
                loadingPosition="end"
                variant="contained"
            >
                Add to cart
            </Button>
        </Box>
    )
}
